import axios from "axios";
import { getTokenContext } from "./Auth0TokenService";

let interceptorsAttached = false;

export const apiClient = axios.create({
  baseURL: window.env.REACT_APP_BASE_URI,
});

// inventory-service validates the same Auth0 JWT as pyctor-saas, so its calls
// need the interceptors too. Interceptors are per instance, not global, so a
// second instance is the only way to give the registry endpoints a token.
export const inventoryClient = axios.create({
  baseURL: window.env.INVENTORY_API_BASE_URI,
});

const attachAuth0Interceptors = (client) => {
  client.interceptors.request.use(
    async (config) => {
      const { getAccessTokenSilently } = getTokenContext();

      const token = await getAccessTokenSilently();

      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;

      return config;
    },
    (error) => Promise.reject(error)
  );

  client.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;

      if (
        error.response?.status === 401 &&
        originalRequest &&
        !originalRequest._auth0Retry
      ) {
        originalRequest._auth0Retry = true;

        try {
          const { getAccessTokenSilently } = getTokenContext();

          const token = await getAccessTokenSilently({
            cacheMode: "off",
          });

          originalRequest.headers =
            originalRequest.headers || {};

          originalRequest.headers.Authorization =
            `Bearer ${token}`;

          return client(originalRequest);
        } catch (refreshError) {
          const { logout } = getTokenContext();

          await logout({
            logoutParams: {
              returnTo: `${window.location.origin}/login`,
            },
          });

          return Promise.reject(refreshError);
        }
      }

      return Promise.reject(error);
    }
  );
};

export const initializeAuth0Axios = () => {
  if (interceptorsAttached) {
    return;
  }

  interceptorsAttached = true;

  attachAuth0Interceptors(apiClient);
  attachAuth0Interceptors(inventoryClient);
};
